import { Box, Flex, H2, H3, H4 } from '@ouster/webviz-react-components';

import { Link } from 'react-router';
import { buildTalkToSalesLink } from 'src/utils/talkToSales';

import styles from '../PublicPage.module.css';
import demoStyles from './inAppDemo.module.css';
import { getInAppDemoBackgroundStyle } from './inAppDemoThumbnails';

export default function PublicRecordings() {
  return (
    <Box
      className={`${demoStyles['page-container']}`}
      data-testid="public-recordings-root"
    >
      <H2
        fontWeight="medium"
        fontSize={30}
        data-testid="public-recordings-title"
      >
        Visualize Lidar Data, Anywhere.
      </H2>
      <Box
        className={`${demoStyles['page-content']}`}
        data-testid="public-recordings-content"
      >
        <Box
          className={demoStyles['text-area']}
          data-testid="public-recordings-text-area"
        >
          {/* brief */}
          <Box
            className={`${demoStyles.brief}`}
            data-testid="public-recordings-brief-section"
          >
            <p>
              This is where lidar data comes to life. Upload recordings to
              securely store, visualize, and analyze them in the cloud.{' '}
              <strong>
                Get 250GB of secure cloud storage with a free account.
              </strong>{' '}
              Collaborate seamlessly with a team and access data from any
              device, anytime.
            </p>
            <Flex gap={4} alignItems="center">
              <Link
                to="/sign_up"
                className={`${styles['primary-button']}`}
                style={{
                  fontWeight: 500,
                  width: '300px',
                  justifyContent: 'center',
                }}
                data-testid="public-recordings-signup-link"
              >
                Sign Up to Upload Recordings
              </Link>
              <Link
                to="/login"
                className={`${styles['link-button-secondary']}`}
                data-testid="public-recordings-login-link"
              >
                Already a member? Log in
              </Link>
            </Flex>
          </Box>

          {/* go public */}
          <Box className={`${demoStyles.brief}`}>
            <H3 fontSize={24} fontWeight="medium">
              Want to see Ouster Studio in action first?
            </H3>
            <p>
              Explore Ouster Studio with a public collection of sample datasets.
              It&apos;s the perfect way to experience our visualization tools
              before uploading personal lidar data.
            </p>
            <Link
              to="/public/sample_library/public_collection"
              className={`${styles['primary-button']} `}
              style={{
                fontWeight: 500,
                width: '300px',
                justifyContent: 'center',
              }}
              data-testid="public-recordings-explore-link"
            >
              Explore Public Sample Data
            </Link>
          </Box>

          {/* talk to sale */}
          <Box fontSize={16} display="grid" rowGap={6} maxW="75ch">
            <H4 lineHeight={1.5} fontWeight="medium" color="gray.400">
              Ready to discuss your project needs and learn how Ouster can
              provide a tailored solution?
            </H4>
            <Link
              to={buildTalkToSalesLink('Public Organization Recordings')}
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles['primary-button']}`}
              style={{
                fontWeight: 500,
                width: '300px',
                justifyContent: 'center',
              }}
              data-testid="public-recordings-talk-to-sales-link"
            >
              Talk to Sales
            </Link>
          </Box>
        </Box>

        <Box
          className={`${demoStyles['image-area']}`}
          style={getInAppDemoBackgroundStyle('recording_bg.png')}
        />
      </Box>
    </Box>
  );
}
